import * as React from 'react';
import 'dayjs/locale/de';
import { useConfig } from './ConfigContext'
import styles from '../css/SmallConfigLicht.module.css'
import {styled} from '@mui/system';
import axios from "axios";
import {useEffect, useState} from "react";
import dayjs from "dayjs";
import {ChartContainer, ChartsReferenceLine, ChartsXAxis, ChartsYAxis, ResponsiveChartContainer} from "@mui/x-charts";
import '../styles.css'
import '../css/Configuration.css';
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import {Unstable_NumberInput as BaseNumberInput} from "@mui/base/Unstable_NumberInput";
import {LineChart, LinePlot} from "@mui/x-charts/LineChart";
import Button from "@mui/material/Button";
import {TimePicker} from "@mui/x-date-pickers/TimePicker";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import { useGrowSetup } from '../GrowSetupContext';
import {
    Card,
    CardContent,
    Typography,
    Box,
    Grid2,
    useTheme
  } from "@mui/material";



const marks = [
    {
        value: 0,
        label: '0°C',
    },
    {
        value: 20,
        label: '20°C',
    },
    {
        value: 37,
        label: '37°C',
    },
];

function valuetext(value) {
    return `${value}°C`;
}

function valuetextAbweichung(value) {
    return `${value}%`;
}


export default function SmallConfigLicht(props) {
  
    const theme = useTheme();
    const { state, dispatch, saveConfig, config} = useConfig()
    const { grow_setup, setGrowSetup } = useGrowSetup();
    const [ dauer, setDauer ] = useState(30);



    useEffect(() => {
        //setGrowSetup(grow_setup);

        if(!props.is_managed){
          //fetchData();
        }
    }, []);


    var begin_of_day = dayjs("01/01/2024 00:00");
    var end_of_day = dayjs("01/02/2024 00:00");

    function change_dauer(e, v) {
      setDauer(v);
      dispatch({ type: 'SET_FIELD', field: 'dauer', value: v });

      const sunrise = state.config.sun_rise_dayjs
        ? dayjs(state.config.sun_rise_dayjs)
        : dayjs("01/01/2024 " + state.config.sun_rise);

      const sunset = state.config.sun_set_dayjs
        ? dayjs(state.config.sun_set_dayjs)
        : dayjs("01/01/2024 " + state.config.sun_set_end);

      // Neue Endzeiten berechnen
      const sunRiseEnd = sunrise.add(v, "minute");
      const sunSet = sunset.subtract(v, "minute");

      dispatch({
        type: "SET_FIELD",
        field: "sun_rise_end",
        value: sunRiseEnd.format("HH:mm"),
      });
      dispatch({
        type: "SET_FIELD",
        field: "sun_set",
        value: sunSet.format("HH:mm"),
      });
    }

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
         
    <Card sx={{ backgroundColor: theme.palette.background.paper, color: theme.palette.text.primary,minHeight:632, borderRadius: 3, p: 2, boxShadow: 3,maxWidth: 600 }}>
      <Typography variant="h4" gutterBottom>Licht</Typography>

      <CardContent>
        <Grid2 container spacing={2}>
          <Grid2 item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
            <Typography variant="subtitle1">Sonnenaufgang</Typography>
            <TimePicker
              ampm={false}
              label="Sonnenaufgang"
              views={['hours', 'minutes']}
              format="HH:mm"
              value={dayjs().hour(state.config.sun_rise.split(':')[0]).minute(state.config.sun_rise.split(':')[1])}
              onChange={e => {
                const x = dayjs(e);
                dispatch({ type: 'SET_FIELD', field: 'sun_rise', value: x.format("HH:mm") })
                dispatch({ type: 'SET_FIELD', field: 'sun_rise_dayjs', value: x })
                dispatch({ type: 'SET_FIELD', field: 'sun_rise_end', value: x.add(dauer, 'minute').format("HH:mm") })
              }}
            />
          </Grid2>

          <Grid2 item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
            <Typography variant="subtitle1">Sonnenuntergang</Typography>
            <TimePicker
              ampm={false}
              label="Sonnenuntergang"
              views={['hours', 'minutes']}
              format="HH:mm"
              value={dayjs("01/01/2024 " + state.config.sun_set_end)}
              onChange={e => {
                const y = dayjs(e);
                dispatch({ type: 'SET_FIELD', field: 'sun_set_end', value: y.format("HH:mm") })
                dispatch({ type: 'SET_FIELD', field: 'sun_set_dayjs', value: y })
                dispatch({ type: 'SET_FIELD', field: 'sun_set', value: y.subtract(dauer, 'minute').format("HH:mm") })
              }}
            />
          </Grid2>

          <Grid2 item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
            <Typography variant="subtitle1">Dämmerungstimer in Minuten</Typography>
            <BaseNumberInput
              slots={{
                root: StyledInputRoot,
                input: StyledInput,
                incrementButton: StyledButton,
                decrementButton: StyledButton,
              }}
              slotProps={{
                incrementButton: {
                  children: <AddIcon fontSize="small" />,
                  className: 'increment',
                },
                decrementButton: {
                  children: <RemoveIcon fontSize="small" />,
                },
              }}
              min={0} step={10} max={120}
              onChange={change_dauer}
              value={state.config.dauer}
            />
          </Grid2>

          <Grid2 item size={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
            <Typography variant="subtitle1">Max. Lichtintensität in %</Typography>
            <BaseNumberInput
              slots={{
                root: StyledInputRoot,
                input: StyledInput,
                incrementButton: StyledButton,
                decrementButton: StyledButton,
              }}
              slotProps={{
                incrementButton: {
                  children: <AddIcon fontSize="small" />,
                  className: 'increment',
                },
                decrementButton: {
                  children: <RemoveIcon fontSize="small" />,
                },
              }}
              min={0} step={10} max={100}
              value={state.config.max_intensity_light}
              onChange={(e, v) => {
                dispatch({ type: 'SET_FIELD', field: 'max_intensity_light', value: v })
              }}
            />
          </Grid2>
        </Grid2>
      </CardContent>

      <CardContent sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <LineChart
                    xAxis={[{
                        data: [begin_of_day, dayjs("01/01/2024 " + state.config.sun_rise), dayjs("01/01/2024 " + state.config.sun_rise_end), dayjs("01/01/2024 " + state.config.sun_set), dayjs("01/01/2024 " + state.config.sun_set_end), end_of_day],
                        scaleType: 'time'
                    }]}
                    yAxis={[{max: 100}]}
                    series={[
                        {
                            data: [0, 0, state.config.max_intensity_light, state.config.max_intensity_light, 0, 0],
                        },
                    ]}

                    width={300}
                    height={300}
                />
      </CardContent>

      {props.is_managed ? <div></div> : 
      <Button fullWidth variant="contained" color="success" sx={{mt: 2}} onClick={saveConfig}>
        Speichern
      </Button>
      }
    </Card>
        </LocalizationProvider>
    );
}


const blue = {
    100: '#daecff',
    200: '#b6daff',
    300: '#66b2ff',
    400: '#3399ff',
    500: '#007fff',
    600: '#0072e5',
    700: '#0059B2',
    800: '#004c99',
};

const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
};

const StyledInputRoot = styled('div')(
    ({theme}) => `
  font-family: 'IBM Plex Sans', sans-serif;
  font-weight: 400;
  color: ${theme.palette.mode === 'dark' ? grey[300] : grey[500]};
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
`,
);

const StyledInput = styled('input')(
    ({theme}) => `
  font-size: 0.875rem;
  font-family: inherit;
  font-weight: 400;
  line-height: 1.375;
  color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
  background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
  border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
  box-shadow: 0px 2px 4px ${
        theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
    };
  border-radius: 8px;
  margin: 0 8px;
  padding: 10px 12px;
  outline: 0;
  min-width: 0;
  width: 4rem;
  text-align: center;

  &:hover {
    border-color: ${blue[400]};
  }

  &:focus {
    border-color: ${blue[400]};
    box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[700] : blue[200]};
  }

  &:focus-visible {
    outline: 0;
  }
`,
);

const StyledButton = styled('button')(
    ({theme}) => `
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 0.875rem;
  box-sizing: border-box;
  line-height: 1.5;
  border: 1px solid;
  border-radius: 999px;
  border-color: ${theme.palette.mode === 'dark' ? grey[800] : grey[200]};
  background: ${theme.palette.mode === 'dark' ? grey[900] : grey[50]};
  color: ${theme.palette.mode === 'dark' ? grey[200] : grey[900]};
  width: 32px;
  height: 32px;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 120ms;

  &:hover {
    cursor: pointer;
    background: ${theme.palette.mode === 'dark' ? blue[700] : blue[500]};
    border-color: ${theme.palette.mode === 'dark' ? blue[500] : blue[400]};
    color: ${grey[50]};
  }

  &:focus-visible {
    outline: 0;
  }

  &.increment {
    order: 1;
  }
`,
);